module.exports = __webpack_public_path__ + "img/auto.1db766d8.svg";